<script>
import { mapState, mapActions } from 'vuex';
/* components */
import FullScreenOverlay from '@/components/FullScreenOverlay';
import Button from '@/components/Button';

/* tools */
import {} from '@/scripts/utils';
import { onboardingBackground } from '@/scripts/computed';

export default {
  name: 'InstructionsExecuted',
  components: {
    Button,
    FullScreenOverlay,
  },
  props: {
    setup: {
      type: Object,
      required: true,
    },
    activeGame: {
      type: String,
      required: true,
    },
    linkTo: {
      type: String,
      default: '/settings',
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user']),
    onboardingBackground,
  },
  created() {
    const { activeGame, setup } = this;

    if (!activeGame || !setup)
      this.$router.push({
        name: 'Onboarding',
        params: { option: 'connect-game', errorState: true },
      });
  },
  mounted() {},
  methods: {
    ...mapActions({}),
  },
};
</script>

<template>
  <FullScreenOverlay
    :style="onboardingBackground"
    :class="{ shadowBg: onboardingBackground }"
  >
    <div class="thanks">
      <div class="thanks__title">Thank You!</div>
      <div v-html="setup.thankYouNote" class="thanks__text"></div>
      <div class="thanks__action">
        <Button :to="linkTo" class="blue default m-290">
          Done
        </Button>
        <Button to="/onboarding/connect-game" class="link-white">
          Do you want to connect to other games?
        </Button>
      </div>
    </div>
  </FullScreenOverlay>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.thanks {
  margin-top: 130px;

  &__title {
    font-family: Sen-Bold;
    font-size: 36px;
    line-height: 43px;
    color: #ffd300;
    text-align: center;
    text-transform: uppercase;

    & + .thanks__text {
      margin-top: 15px;
    }
  }

  &__text {
    max-width: 770px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    font-family: Poppins-Light;
    font-size: 18px;
    line-height: 1.5;
    color: #ffffff;
  }

  &__action {
    margin-top: 50px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .button + .link-white {
      margin-top: 20px;
    }
  }
}

@media (max-width: $mobile) {
  .thanks {
    margin-top: 0;
    padding-top: 53px;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    &__title {
      font-size: 24px;
      line-height: 43px;

      & + .thanks__text {
        margin-top: 20px;
      }
    }

    &__text {
      font-size: 14px;
      line-height: 1.93;
    }

    &__action {
      flex-grow: 1;
      display: flex;
      justify-content: flex-end;

      .button + .link-white {
        margin-top: 25px;
      }
    }
  }
}

::v-deep p {
  margin: 0;
}
</style>
